import { connect } from 'react-redux';
import MatchStatsForm from './MatchStatsForm';
import State from '../../../../models';

const mapStateToProps = ({ calendar: { loading } }: State) => ({
  loading,
});

export default connect(mapStateToProps)(MatchStatsForm);
